export default __webpack_public_path__ + "static/media/ir.70f27c35.jpg";